<template>
  <v-dialog v-model="loading" max-width="40%">
    <v-card>
      <v-card-text>
        <v-progress-linear
          indeterminate
          color="primary"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "CustomerAccountProduction",
  props: {
    customers: Array,
    products: Array,
    productsPrices: Array,
    orders: Array,
    ordersQty: Array,
    days: Array,
    date: Object
  },
  data() {
    return {
      loading: false
    };
  },
  async created() {
    this.loading = true;
    this.createPdf();
    this.loading = false;
    this.$emit("done");
  },
  methods: {
    createPdf() {
      const fileName = "production_semaine_du_" + this.date;
      let tableData = [];
      this.orders.forEach(order => {
        let tableDataByOrder = [
          [
            { text: " ", style: "clientTableHeader" },
            { text: "Lundi", style: "clientTableHeader" },
            { text: "Mardi", style: "clientTableHeader" },
            { text: "Mercredi", style: "clientTableHeader" },
            { text: "Jeudi", style: "clientTableHeader" },
            { text: "Vendredi", style: "clientTableHeader" },
            { text: "Total", style: "clientTableHeader" }
          ]
        ];
        this.products.forEach(p => {
          let rowLine = [p.nom];
          let qty = 0;
          this.days.forEach(d => {
            let dailyQuery = this.ordersQty.find(
              i =>
                i.commande === order.id_commande &&
                i.produit === p.id_produit &&
                i.jour === d
            );
            let dailyQty =
              typeof dailyQuery !== "undefined" ? dailyQuery.quantite : 0;
            rowLine.push(dailyQty);
            qty += dailyQty;
          });
          rowLine.push(qty);
          if (qty > 0) {
            tableDataByOrder.push(rowLine);
          }
        });
        let tableDataWithTitle = [
          {
            text: this.customers.find(c => c.id_client === order.client).nom,
            style: "clientHeader"
          },
          tableDataByOrder
        ];
        tableData.push(tableDataWithTitle);
      });
      let tableDataTotal = [
        [
          { text: " ", style: "tableHeader" },
          { text: "Lundi", style: "tableHeader" },
          { text: "Mardi", style: "tableHeader" },
          { text: "Mercredi", style: "tableHeader" },
          { text: "Jeudi", style: "tableHeader" },
          { text: "Vendredi", style: "tableHeader" },
          { text: "Total", style: "tableHeader" }
        ]
      ];
      this.products.forEach(p => {
        let rowLine = [p.nom];
        let qty = 0;
        this.days.forEach(d => {
          let dailyQuery = this.ordersQty.filter(
            i => i.produit === p.id_produit && i.jour === d
          );
          let dailyQty =
            typeof dailyQuery !== "undefined" && dailyQuery.length !== 0
              ? dailyQuery.map(dq => dq.quantite).reduce((a, b) => a + b)
              : 0;
          rowLine.push(dailyQty);
          qty += dailyQty;
        });
        rowLine.push(qty);
        if (qty > 0) {
          tableDataTotal.push(rowLine);
        }
      });
      let formatedOrdersTable = [];
      tableData.forEach(t => {
        formatedOrdersTable.push(
          t[0],
          {
            table: {
              headerRows: 1,
              widths: [160, 38, 38, 48, 40, 48, 50],
              body: t[1]
            },
            layout: "lightHorizontalLines"
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 520,
                y2: 5,
                lineWidth: 1
              }
            ]
          },
          " "
        );
      });
      let document = {
        info: {
          title: fileName
        },
        content: [
          { text: "Production Total", style: "header" },
          {
            table: {
              headerRows: 1,
              widths: [160, 38, 38, 48, 40, 48, 50],
              body: tableDataTotal
            },
            layout: "lightHorizontalLines"
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 520,
                y2: 5,
                lineWidth: 4
              }
            ]
          },
          " ",
          ...formatedOrdersTable
        ],
        styles: {
          header: {
            fontSize: 15,
            bold: true
          },
          clientHeader: {
            fontSize: 13,
            bold: true
          },
          small: {
            fontSize: 8,
            color: "#BDBDBD",
            alignment: "right"
          },
          tableHeader: {
            bold: true,
            color: "black"
          },
          clientTableHeader: {
            color: "black"
          },
          tableHeaderRigth: {
            bold: true,
            color: "black",
            alignment: "right"
          },
          rigthAlign: {
            alignment: "right"
          }
        }
      };
      pdfMake.createPdf(document).download(fileName);
    }
  }
};
</script>

<style scoped></style>
